import type { Drug } from "../../types";

const storageNote =
  "Store in original blister. Protect from moisture and light. No cold chain — no special temperature requirements. Shelf life 3 years.";

export const oralSemaglutideDrug: Drug = {
  id: "oral_semaglutide",
  name: "Semaglutide (Wegovy® tablets)",
  drugClass: "GLP-1 receptor agonist",
  route: "oral",
  defaultFoodTiming:
    "Take on an empty stomach after a fast of at least 8 hours. Wait at least 30 minutes before any food, drink, or other oral medicine.",
  formulations: [
    { id: "oral-sema-1_5mg-tablet", type: "tablet_ir", strength: 1.5, strengthUnit: "mg", storageNote },
    { id: "oral-sema-4mg-tablet", type: "tablet_ir", strength: 4, strengthUnit: "mg", storageNote },
    { id: "oral-sema-9mg-tablet", type: "tablet_ir", strength: 9, strengthUnit: "mg", storageNote },
    { id: "oral-sema-25mg-tablet", type: "tablet_ir", strength: 25, strengthUnit: "mg", storageNote },
  ],
};
